import { render, staticRenderFns } from "./InsertOXml.vue?vue&type=template&id=49dd36da&"
import script from "./InsertOXml.vue?vue&type=script&lang=js&"
export * from "./InsertOXml.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports